// Shared theme asset URLs. THEME_OVERLAYS lives per-component because the
// formats differ (Tailwind classes in +layout, rgba strings in Splash).
import type { Theme } from './settings';

export const THEME_VIDEOS: Record<Theme, string> = {
	hearth: 'https://assets.bubblegames.app/hearth.mp4',
	galactic: 'https://assets.bubblegames.app/galactic.mp4',
	wizardry: 'https://assets.bubblegames.app/wizardry.mp4',
	overgrown: 'https://assets.bubblegames.app/overGrown.mp4',
	outbreak: 'https://assets.bubblegames.app/outbreak.mp4',
	catchers: 'https://assets.bubblegames.app/catchers.mp4',
	noir: 'https://assets.bubblegames.app/noir.mp4',
	dark: '',
	light: ''
};

export const THEME_PREVIEWS: Record<Theme, string> = {
	hearth: '/themes/hearth.jpg',
	galactic: '/themes/galactic.jpg',
	wizardry: '/themes/wizardry.jpg',
	overgrown: '/themes/overGrown.jpg',
	outbreak: '/themes/outbreak.jpg',
	catchers: '/themes/catchers.jpg',
	noir: '/themes/noir.jpg',
	dark: '',
	light: ''
};
